/**
 * MarketingStrategyPage — Sprint 3 · Project Symphony
 *
 * Route: /campaigns/:blueprintId/strategy
 *
 * Patch 34.1.12 — WorkspaceGate replaces the hard `/welcome` redirect.
 * The founder no longer sees the "We couldn't load this campaign"
 * flash on a transient hydration cycle.
 */
import { MarketingStrategyView } from "@/features/marketing-strategy";
import { WorkspaceGate } from "@/widgets/WorkspaceGate/WorkspaceGate";

export default function MarketingStrategyPage(): JSX.Element {
  return <WorkspaceGate>{() => <MarketingStrategyView />}</WorkspaceGate>;
}
